import React from 'react';
type Tome = {
  number: string;
  title: string;
  sessions: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Foundations: Grip, Serve & First Rallies',
  sessions: 'Sessions 1–13',
  promise: 'Take a total beginner from never holding a racket to serving, rallying and scoring their first points.',
  badge: 'bg-court text-white',
  contents: ['The Court-Ready Session Formula in short, medium and full versions', 'The First-Contact Ladder: hand-feed → self-feed → live rally', 'Grip, ready position and the ready-hop they will actually use', 'Low serve and high serve, each built in one session', 'First singles and doubles games with simple scoring', 'Your first four weeks with a new group, at a glance']
}, {
  number: '02',
  title: 'The Backcourt: Overhead Clears, Drops & Smash Power',
  sessions: 'Sessions 14–26',
  promise: 'One overhead action that delivers the clear, the drop and the smash.',
  badge: 'bg-night text-white',
  contents: ['The Overhead Stroke Cycle: throw → hit → recover', 'Clears to the back line, with depth-target games', 'The Clear-Drop-Smash Tree: one preparation, three outcomes', 'Slow and fast drops disguised to look like the clear', 'The Power Chain for a first controlled smash', 'The backcourt decision session: clear, drop or smash?']
}, {
  number: '03',
  title: 'The Frontcourt: Net Shots, Lifts & Kills',
  sessions: 'Sessions 27–39',
  promise: 'Soft hands, net battles and finishing at the front of the court.',
  badge: 'bg-green text-white',
  contents: ['The Soft-Hands Scale: grip pressure from 1 to 5', 'Tight net shots and spinning net shots', 'The Net Decision Gate: net shot or lift?', 'Defensive and attacking lifts under pressure', 'Net kills from a loose shuttle, without touching the net', 'Front-court circuits for mixed-ability groups']
}, {
  number: '04',
  title: 'Movement & Defence: Footwork, Court Coverage & Returns',
  sessions: 'Sessions 40–52',
  promise: 'The engine of the game: split step, four-corner coverage and a defence that turns into attack.',
  badge: 'bg-coral text-white',
  contents: ['The Split-Step Clock and recovery to base', 'Chassé footwork vs running: shadow drills to all 4 corners', 'Safe lunging technique at the net', 'The 4-Corner Coverage Grid and early-read games', 'Smash defence: the block return and the drive return', 'Return-of-serve session for singles and doubles']
}, {
  number: '05',
  title: 'Doubles & Tactics: Partner Play, Rotation & Shot Choice',
  sessions: 'Sessions 53–65',
  promise: 'Teach players to choose the right shot, not just hit it.',
  badge: 'bg-shuttle text-ink',
  contents: ['The Shot-Choice Triangle: where, when and why', 'Singles patterns: move them, then finish', 'The Attack/Defence Rotation for doubles', 'Mixed doubles basics: covering the roles', 'The Serve-and-Follow play and third-shot setups', 'Playing the big points under scoreboard pressure']
}, {
  number: '06',
  title: 'Match Play & Assessment: Games, Competition Prep & Progress',
  sessions: 'Sessions 66–77',
  promise: 'Turn skills into real games, prep for competition and show the progress.',
  badge: 'bg-court-deep text-white',
  contents: ['Conditioned games that reward the skill you are teaching', 'Self-running round-robins and King/Queen of the court', 'Handicap formats for mixed-ability matches', 'The Pre-Match Routine and a competition warm-up', 'The Progress Anchor: skills benchmarks for every block', 'A season planner that maps all six blocks onto your weeks']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-white" data-id="element-322" data-mp="3va4houtjcn0f">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-323" data-mp="3c85e2pb12dh1">
        <div className="text-center" data-id="element-324" data-mp="379kdgorv5rs2">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-325" data-mp="37alynm2lfuni">
            The complete playbook
          </p>
          <h2 id="tomes-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-326" data-mp="3h78kad2qupql">
            Inside the pack — six volumes, one full season
          </h2>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-327" data-mp="3pz0qgbkqjcpd">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col rounded-2xl border border-line bg-white p-6 shadow-card" data-id="element-328" data-mp="8p2mlnahb7xj">
              <div className="flex items-center gap-2.5" data-id="element-329" data-mp="2ajjp2qvepdba">
                <span className={`flex h-9 w-9 items-center justify-center rounded-lg font-display text-base font-extrabold ${tome.badge}`} data-id="element-330" data-mp="25jfaj6e26snp">
                  {tome.number}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-331" data-mp="q0r65ro1iqwx">
                  Volume {tome.number} · {tome.sessions}
                </span>
              </div>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-ink" data-id="element-332" data-mp="g9wf89zun355">
                {tome.title}
              </h3>
              <p className="mt-2 text-sm text-ink-soft" data-id="element-333" data-mp="29lor82gbqki">{tome.promise}</p>
              <ul className="mt-4 grid gap-2 border-t border-line pt-4" data-id="element-334" data-mp="6d9vxpn68k58">
                {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-ink" data-id="element-335" data-mp="3ojxyb7qu6t77">
                    <span className="mt-[7px] h-1.5 w-1.5 flex-none rounded-full bg-court" data-id="element-336" data-mp="3thzjpzbqj4lu" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}